
export const WidgetStateNavigator = ({stagesCount , activeIndex} : {activeIndex:number , stagesCount: number}) => {
    return (
        <div className="w-full bg-muted h-2 rounded-full absolute inset-0">
            <div
                className="bg-primary h-full rounded-full"
                style={{ width: `${((activeIndex+1) / stagesCount) * 100}%` }}
            ></div>
        </div>
    )
}